import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoginService } from 'src/app/services/security/login.service';
import { Notifications } from 'src/app/services/shared/notifications.service';
import * as signalR from '@microsoft/signalr'
import { NotificationDto } from 'src/app/interfaces/Dtos/notification-dto';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'neoris-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})
export class HomePageComponent implements OnInit, OnDestroy {

  private _hubConnection: signalR.HubConnection
  loginResponse: any
  private gridNotificationSubscription: Subscription
  public location: string = "";
  
  constructor(private securityService: LoginService,
    private controltowerservice: ControltowerService
  ) { 
  }

  async ngOnInit(): Promise<void> {
    


    const userName = JSON.parse(localStorage.getItem('ud'))[1].value
    const response = await this.securityService.login(userName,"").toPromise()

    var guidSession = JSON.stringify(response.oobjectuuid.toString());
    localStorage.setItem('guidSession', guidSession)   

    this.loginResponse = response


    var sites = "5000"

    var sitesIds = []
    sites.split(',').forEach(site => {
      sitesIds.push(Number.parseInt(site))
    });

    var request = {
      SitesId: sitesIds
    }
    
    
    // if ((window as any).clarity) {
    //   (window as any).clarity('identify', guidSession, {
    //     userName: userName
    //   });
    // } else {
    //   console.warn('Clarity no está disponible');
    // }


    this.getNotificationConfiguration(request)
    
    


    
  }

  
  
  ngOnDestroy(): void {
  }

  private async getSites(): Promise<boolean> {

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getSites().subscribe(
        {
          next: (sites: any) => {
            if(sites.length > 0){
              var firstSiteId = sites[0].id
              this.getNotificationConfiguration(firstSiteId)
            }
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  public alertType: string = "";

  private async getNotificationConfiguration(params: any): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {

      this.controltowerservice.getNotificationConfigurationBySites(params).subscribe(
        {
          next: (conf: any) => {

       

            var appNotifications = conf.filter((item: any) => item.name == "APP NOTIFICATION");

            if(appNotifications.length > 0){

            var alertTypeId = appNotifications[0].alertTypeId;

            switch(alertTypeId){
              case 13207:
                this.alertType = "I4SAFETY_BOX";
                break;
              case 13208:
                this.alertType = "I4SAFETY_MINI";
                break;
            }

            }

            console.log("appNotifications", appNotifications)
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )

    });
  }

  
}
